import React from "react";
import { ThumbnailsBlock } from '../ThumbnailsBlock';

export const ProgramsBlock = ({ programs, ...props }) => (
    <ThumbnailsBlock thumbnails={programs} {...props} />
)